module.exports = __webpack_public_path__ + "img/9-September.6583f29c.jpg";